import React from "react";

const TermsConditions = () => {
  return (
    <div style={{ padding: "40px", paddingTop: "120px", maxWidth: "900px", margin: "0 auto", fontFamily: "DM Sans, sans-serif", lineHeight: "1.7", color: "#333" }}>
      <h1>Terms & Conditions</h1>
      <p>Last updated: October 2025</p>

      <h2>1. Introduction</h2>
      <p>These Terms and Conditions govern your use of HelloParyatak's website and services. By accessing or using our website, you agree to comply with these terms.</p>

      <h2>2. Booking & Payment</h2>
      <ul>
        <li>All bookings must be made via our official website or authorized channels.</li>
        <li>Payments are processed securely through third-party gateways.</li>
        <li>Prices are subject to change, but confirmed bookings remain at the agreed price.</li>
      </ul>

      <h2>3. Cancellation & Refund</h2>
      <p>Our refund policy applies to cancellations. Please review the Refund Policy for detailed instructions.</p>

      <h2>4. User Responsibilities</h2>
      <ul>
        <li>You agree to provide accurate personal and payment information.</li>
        <li>You agree not to use the website for unlawful activities.</li>
        <li>You are responsible for keeping your account credentials confidential.</li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p>All content on HelloParyatak, including images, logos, text, and software, is the property of HelloParyatak and protected by copyright laws.</p>

      <h2>6. Limitation of Liability</h2>
      <p>HelloParyatak is not liable for any direct, indirect, incidental, or consequential damages arising from the use of our services, website, or travel experiences booked through us.</p>

      <h2>7. Governing Law</h2>
      <p>These Terms and Conditions are governed by the laws of India. Any disputes will be subject to the jurisdiction of Pune courts.</p>

      <h2>8. Changes</h2>
      <p>We may revise these terms periodically. The latest version will always be available on our website.</p>

      <h2>Contact</h2>
      <p>If you have questions about these Terms & Conditions, contact us at <a href="mailto:info@helloparyatak.com">info@helloparyatak.com</a>.</p>
    </div>
  );
};

export default TermsConditions;
